module.exports = __webpack_public_path__ + "img/it.612e617f.svg";